export default __webpack_public_path__ + "static/media/zap_money_logo.bbbdf7f9.png";